/* What the person sees when a save fails. The form, what was typed and the previous data always stay. */
import { FAIL_MESSAGES, type SaveFail } from "../data/store";
import { esc } from "../domain/format";
import { failReasonOf } from "../storage/errors";
import { openRelogin } from "./account";
import { ctx } from "./context";
import { ic } from "./icons";
import { closeSheet, head, openSheet, toast } from "./shell";

export const failOf = (e: unknown): SaveFail => { const reason = failReasonOf(e); return { ok: false, reason, message: FAIL_MESSAGES[reason] }; };

/** Loads the latest saved copy and redraws the screen behind any open sheet. */
export async function reloadLatest(): Promise<boolean> {
  const r = await ctx.store.reload();
  if (!r.ok) { if (r.reason !== "account") toast(r.message); return false; }
  if (!ctx.store.started) { ctx.V.view = "welcome"; ctx.V.catId = null; }
  ctx.render();
  return true;
}

function markSessionLost() {
  if (ctx.mode === "cloud" && ctx.account && !ctx.sessionLost) { ctx.sessionLost = true; ctx.render(); }
}

/**
 * Failure shown inside a sheet. A conflict gets a "load latest" button (then onReloaded runs, e.g. to reopen the
 * form with the latest data and the person's own edits); an expired session gets a "sign in again" button.
 */
export function showFail(el: HTMLElement, r: SaveFail, onReloaded?: () => void) {
  if (r.reason === "account") return; // the account changed; nothing of the old one is shown
  if (r.reason === "session") markSessionLost();
  el.innerHTML = esc(r.message)
    + (r.reason === "conflict" ? `<button type="button" class="btn" data-fail="reload" id="btn-load-latest">${ic("left")}โหลดข้อมูลล่าสุด</button>`
      : r.reason === "session" ? `<button type="button" class="btn" data-fail="login" id="btn-relogin-inline">${ic("user")}เข้าสู่ระบบอีกครั้ง</button>` : "");
  el.hidden = false;
  el.querySelector<HTMLButtonElement>("[data-fail=reload]")?.addEventListener("click", async ev => {
    const b = ev.currentTarget as HTMLButtonElement; b.disabled = true;
    if (!(await reloadLatest())) { b.disabled = false; return; }
    if (onReloaded) onReloaded();
    else { el.hidden = true; toast("โหลดข้อมูลล่าสุดแล้ว ลองอีกครั้งได้"); }
  });
  el.querySelector("[data-fail=login]")?.addEventListener("click", () => openRelogin());
}

/** Failure of a tap that has no form (switch a setting, add sample data, …). */
export function failNotice(r: SaveFail) {
  if (r.reason === "account") return;
  if (r.reason === "session") { markSessionLost(); toast(r.message); openRelogin(); return; }
  if (r.reason !== "conflict") { toast(r.message); return; }
  openSheet(head("ข้อมูลเปลี่ยนจากอีกเครื่อง")
    + `<p class="note" id="cf-text">${esc(r.message)}</p>`
    + `<button class="btn primary" id="cf-reload" style="width:100%">${ic("left")}โหลดข้อมูลล่าสุด</button>`,
  sh => {
    const b = sh.querySelector<HTMLButtonElement>("#cf-reload")!;
    b.onclick = async () => { b.disabled = true; if (await reloadLatest()) { closeSheet(); toast("โหลดข้อมูลล่าสุดแล้ว ลองอีกครั้งได้"); } else b.disabled = false; };
  });
}
